import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import AdminHeader from './AdminHeader'

export default function EditDepartment() {
    const { id } = useParams()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        department_name:'',
        description:''
    })

    const [errors, setErrors] = useState({
        department_name:'',
        description:'',
    })

    const fetchDepartments = async() => {
        try{
            const res = await axios.get(`${config.baseurl}get_all_departments/`,{
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('All Departments:', res.data)

            if(res.status === 200){
                const selectedDepartment = res.data.data.find((item) => String(item.id) === String(id))
                console.log('selected department:', selectedDepartment)

                if(selectedDepartment){
                    console.log('selected department:', selectedDepartment)
    
                    setFormData({
                        department_name:selectedDepartment.department_name || '',
                        description: selectedDepartment.description || ''
                    })
                }else{
                    toast.error('Department not found')
                    navigate('/admin/all_departments')
                }
            }
        }catch(error){
            console.error('Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to create branch'

            toast.error(message)
        }
    }

    useEffect(() => {
        if(id){
            fetchDepartments()
        }
    },[id, token, navigate])

    const handleChange = (e) => {
        const {name, value} = e.target

        setFormData((prev) => ({
            ...prev,
            [name]:value
        }))

        let error = ''

        if(name === 'department_name'){
            if(!value.trim()){
                error = 'Department name is required'
            }
        }

        if(name === 'description'){
            if(!value.trim()){
                error = 'Description is required'
            }
        }

        setErrors((prev) => ({
            ...prev,
            [name]:error
        }))
    }

   const validateForm = () => {
    const newErrors = {}

    const departmentName = formData.department_name.trim()
    const description = formData.description.trim()

    if(!departmentName){
        newErrors.department_name = 'Department name is required'
    }

    if(!description){
        newErrors.description = 'Description is required'
    }
        
        setErrors(newErrors)

        return Object.keys(newErrors).length === 0
   }

    const handleUpdate = async(e) => {
        e.preventDefault()

        if(!validateForm()){
            return
        }

        setLoading(true)

        try{

            const payload = {
                department_name:formData.department_name.trim(),
                description:formData.description.trim(),
            }
            console.log('Updating Department Id:', id)
            console.log('Sending Data:', payload)
 
            const res = await axios.put(`${config.baseurl}update_department/${id}/`, payload, {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('Sending Data', formData)

            if(res.status === 200){
                toast.success('Department Updated Successfully')
                navigate('/admin/all_departments')
            }else{
                toast.error('Error occured while updating Department')
            }
        }catch(error){
            console.error('Update Department Error:',error.response?.data); // show full response in console

            const message =
                error.response?.data?.error?.[0] ||
                error.response?.data?.message ||
                "Error occurred";

            toast.error(message);
        }finally{
            setLoading(false)
        }
    }

    const inputClass ='w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
        <AdminHeader/>

        <div className='max-w-7xl mx-auto px-6 pt-16 pb-6'>
            <div className='items-center justify-between text-center'>
                <h2 className='text-3xl font-bold mb-1'>Edit Department</h2>
                <p className='mt-2 text-sm text-slate-500'>
                    Update the department details below
                </p>
            </div>
        </div>

        <div className='max-w-7xl mx-auto px-6 pb-12 justify-between items-center'>
            <div className='mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg'>
                <div className='border-b border-slate-200 bg-slate-50 px-6 py-5 text-center text-lg'>
                    <h2 className='text-lg font-bold'>Department Registration Form</h2>
                </div>

                {/* Form */}
                <form onSubmit={handleUpdate} className="p-6 md:p-8">
                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

                        {/* Department Name */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="department_name"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Department Name
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="department_name"
                                type="text"
                                name="department_name"
                                placeholder="Enter branch name"
                                value={formData.department_name}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.department_name
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.department_name && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.department_name}</p>
                            )}
                        </div>

                        {/* Description */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="description"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Description
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <textarea
                                id="description"
                                name="description"
                                rows={4}
                                placeholder="Enter complete description"
                                value={formData.description}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.description
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.description && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.description}</p>
                            )}
                        </div>
                    </div>

                    {/* Form Actions */}
                    <div className="mt-8 flex flex-col-reverse gap-3 border-t border-slate-200 pt-6 sm:flex-row justify-end">
                        <button
                            type="button"
                            disabled={loading}
                            onClick={() => navigate('/super_admin/all_branches')}
                            className="rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            disabled={loading}
                            className="rounded-xl bg-[#000435] px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {loading ? 'Updating...' : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}
